<template>
  <div
    class="shopping-cart-item__list"
    :class="{
      'shopping-cart-item__list_disabled': !product.active,
      'shopping-cart-item__border-bottom': isOrderConfirmation
    }"
  >
    <div
      class="shopping-cart-item__line"
      :class="{
        'shopping-cart-item__order-confirmation': isConfirmation,
        'shopping-cart-item__order-confirmation-has-modifiers': isOrderConfirmation
      }"
    >
      <div class="shopping-cart-item__title">
        <span class="shopping-cart-item__title__margin">{{ `${product.quantity}` }}</span>
        <span class="iw-item-name">{{ `${product.item.name}` }}</span>
      </div>
      <!--            TODO: display discounted prices if promo is applied-->
      <div class="iw-body-text-large shopping-cart-item__price">
        {{ prependUsdSign(product.item.cost * product.quantity) }}
      </div>
    </div>
    <cart-list-item-modifiers-tree class="shopping-cart-item__modifiers-tree" :item="product.item" />
    <div v-if="product.specialInstructions" class="shopping-cart-item__line__instructions">
      <p>&ldquo;{{ product.specialInstructions }}&rdquo;</p>
    </div>
  </div>
</template>

<script>
import CartListItemModifiersTree from "../cart-list-item-modifiers-tree/CartListItemModifiersTree";
import { prependUsdSign } from "@/utils";

export default {
  name: "CartListItem",
  components: { CartListItemModifiersTree },
  props: {
    product: Object,
    isConfirmation: Boolean
  },

  computed: {
    isOrderConfirmation() {
      return this.isConfirmation && this.product.modifiers && Object.keys(this.product.modifiers).length > 0;
    }
  },
  methods: {
    prependUsdSign
  }
};
</script>

<style scoped lang="scss">
.shopping-cart-item {
  &__list {
    &_disabled {
      color: rgba($text-color, 0.4);
    }
  }

  &__line {
    display: flex;
    justify-content: space-between;
    margin-left: 24px;
    @include respond-to-mobile {
      margin-left: 16px;
    }

    &__instructions {
      color: var(--group-3-color-3);
      line-height: 20px;
      margin-left: 64px;

      @include respond-to-mobile {
        margin-left: 54px;
      }
    }
  }

  &__modifiers-tree {
    margin-top: 8px;
  }

  &__order-confirmation {
    padding: 20px 0;
    border-bottom: 1px solid $border-color;
    margin-left: 0px;
  }

  &__order-confirmation-has-modifiers {
    border-bottom: 0;
  }
  &__border-bottom {
    border-bottom: 1px solid $border-color;
    padding-bottom: 23px;
  }

  &__title {
    &__margin {
      margin-right: 32px;
    }
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-weight: normal;
  }

  &__price {
    white-space: nowrap;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    margin: 0;
  }
}
</style>
